import API from '../Api';

export const getBusinessDataApi = (nid) => {
  return API.get(
    process.env.REACT_APP_GET_GENERIC_DATA,
    {
      params: { nid }
    }
  );
};